module.exports = "<my-requests-grid [loadMultiSelectsOnInit]='false'></my-requests-grid>"